module.exports = __webpack_public_path__ + "media/images/custom_page/tempest/buy-prize_2-3bb3c15273d939516de37fbacabae688.png";